import axios from 'axios';

const API_INSTANCE = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
});

API_INSTANCE.defaults.headers.common['Authorization'] = 'Bearer ' + window.localStorage.getItem('governance_token') || ' ';
API_INSTANCE.defaults.headers.common['Content-Type'] = 'application/json';

export const API = API_INSTANCE;